import Keywords from "../collections/keywords";

import Model from "backdraft-app/src/model";

import _ from "underscore";

export default class KeywordsOwner extends Model {
  // this is necessary because of super.constructor() can call parse() and subclasses want to access this.keywords
  get keywords() {
    this._keywords = this._keywords || new Keywords();
    return this._keywords;
  }

  // this is necessary because of super.constructor() can call parse() and subclasses want to access this.defaultSpeaker
  get defaultSpeaker() {
    return 'Agent or Caller';
  }

  setDefaultState() {
    this.keywords.add({ name: "", speaker: this.defaultSpeaker });
    this.set({
      uniq_phrase_said_count: 1,
      total_phrase_said_count: 1,
      any_or_all: "any"
    });
  }

  triggerChanges() {
    // helper that re-trigger changes to allow the UI components to adjust
    // note: the true state of things is always stored in the model and the ui should do nothing but change the model.
    // because of how the radio buttons are interdependent on the phrase count attributes,
    //  doing this in a particuarly order is important, and saving aside the intended value of the any_or_all radio
    const currentAnyOrAll = this.get("any_or_all");
    this.reTriggerChanges();
    this.set("any_or_all", currentAnyOrAll);
    this.keywords.trigger("refresh");
  }

  validate({ any_or_all: anyOrAll, total_phrase_said_count: totalPhraseSaidCount }, options) {
    const errors = {};
    const keywordStats = this.keywords.stats();
    const invalidPhrases = this.keywords.invalidPhrases();

    // validate keywords
    if (keywordStats.unique.length === 0) {
      errors.keywords = "At least one word or phrase is required";
    } else if (!keywordStats.allUnique) {
      errors.keywords = "Words or phrases must be unique";
    } else if (invalidPhrases.length > 0) {
      errors.keywords = `"${invalidPhrases.join(' ,')}" contains unallowed characters(|)`;
    }

    const validateTotalPhraseSaidCount = (!errors.keywords && anyOrAll === "all");

    if (validateTotalPhraseSaidCount) {
      const totalPhraseSaidCountInt = parseInt(totalPhraseSaidCount, 10);
      if (_.isNaN(totalPhraseSaidCountInt)) {
        errors.total_phrase_said_count = "Phrases said count is required";
      } else if (totalPhraseSaidCountInt > 5) {
        errors.total_phrase_said_count = "Phrases can be identified no more than 5 times";
      } else if (totalPhraseSaidCountInt <= 0) {
        errors.total_phrase_said_count = "Phrases must be identified 1 or more times";
      }
    }

    return !_.isEmpty(errors) ? errors : null;
  }

  errorMessages() {
    return _.map(this.validationError, (value, keys) => value).join(", ");
  }

  _phraseCount() {
    return this.get('any_or_all') === 'all' ? this.get('total_phrase_said_count') : this.get('uniq_phrase_said_count');
  }
}
